import "assets/scss/logs.scss";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";

import { SealsTab } from "components/logs/tabs/SealLogs";
import OldOrders from "views/OldOrders.js"
import UnderConstruction from "components/UI/UnderConstruction";

export const LogsMainView = () => {
    const [tab, setTab] = useState("Orders");

    const tabs = [
        { name: "Orders", icon: "fa fa-box" },
        { name: "Seals", icon: "fa fa-lock" },
        { name: "Updates", icon: "fa fa-sync" },
    ]

    return (
        <>
            <div className="warehouse-main-section-buttons-wrapper mb-3">
                <div className="col mx-0 px-0">
                    {
                        tabs.map((tabItem) => (
                            <button
                                key={tabItem.name}
                                className={`warehouse-main-header ${tab === tabItem.name ? "warehouse-active" : ""}`}
                                onClick={() => setTab(tabItem.name)}
                            >
                                <i className={tabItem.icon}></i> {tabItem.name}
                            </button>
                        ))
                    }
                </div>
            </div>
            <div className="warehouse-main-section">
                {tab === "Orders" && <OldOrders />}
                {tab === "Seals" && <SealsTab />}
                {tab === "Updates" && <UnderConstruction />}
            </div>

            <Toaster position="bottom-right" />
        </>
    );
};
